import {
  AccordionBase,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/accordion';
import ArrowDownIcon from '@/components/icons/arrow-down';
import cn from '@/helper/cn';

export type FAQType = {
  items: {
    trigger: string;
    content: string;
    key: string;
  }[];
  title?: string;
} & (
  | {
      type: 'single';
      defaultValue: string;
    }
  | {
      type: 'multiple';
      defaultValue: string[];
    }
);

const FAQ = ({
  type,
  items,
  defaultValue,
  title = 'Frequently Asked Questions',
}: FAQType) => {
  return (
    <>
      <h2 className="mb-5 text-center text-xl font-semibold text-zinc-900 sm:text-2xl lg:mb-10 lg:text-4xl/relaxed">
        {title}
      </h2>
      {type === 'single' ? (
        <AccordionBase
          id="accordion-base"
          type={type}
          defaultValue={defaultValue}
        >
          {items.map((item, idx) => (
            <AccordionItem
              key={item.key}
              value={item.key}
              className={cn(idx === items.length - 1 && 'border-none', '')}
            >
              <AccordionTrigger
                Icon={(prop) => (
                  <ArrowDownIcon
                    {...prop}
                    className="h-6 w-6 shrink-0 text-brand-600"
                  />
                )}
                className="text-sm sm:text-lg lg:text-2xl "
              >
                {item.trigger}
              </AccordionTrigger>
              <AccordionContent className="text-[.63rem] sm:text-base lg:text-lg">
                {item.content}
              </AccordionContent>
            </AccordionItem>
          ))}
        </AccordionBase>
      ) : (
        <AccordionBase
          id="accordion-base"
          type={type}
          defaultValue={defaultValue}
        >
          {items.map((item, idx) => (
            <AccordionItem
              key={item.key}
              value={item.key}
              className={cn(idx === items.length - 1 && 'border-none')}
            >
              <AccordionTrigger
                Icon={(prop) => (
                  <ArrowDownIcon
                    {...prop}
                    className="h-6 w-6 shrink-0 text-brand-600"
                  />
                )}
                className="text-sm sm:text-lg lg:text-2xl "
              >
                {item.trigger}
              </AccordionTrigger>
              <AccordionContent className="text-[.63rem] sm:text-base lg:text-lg">
                {item.content}
              </AccordionContent>
            </AccordionItem>
          ))}
        </AccordionBase>
      )}
    </>
  );
};

export default FAQ;
